import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "@/redux/baseQuery";
import { SiteInfo } from "@/redux/slices/config/types";
import { transformCountries, transformSiteInfo, transformStates } from "./helpers";
import { GetCountriesResponse, GetCountryStatesResponse } from "./types";

export const resourceApi = createApi({
  reducerPath: "resourceApi",
  baseQuery,
  endpoints: (builder) => ({
    getCountryStates: builder.query<GetCountryStatesResponse, string>({
      query: (countryCode) => ({
        url: `/v3/country/${countryCode}/state`,
        params: { page_size: 100 },
      }),
      transformResponse: transformStates,
    }),
    /**
     * Country reference data. Public endpoint — plain `baseQuery` omits the auth header, which is
     * what lets guest routes and onboarding use it. Cached for an hour because this changes about
     * as often as a country does.
     */
    getCountries: builder.query<GetCountriesResponse, void>({
      query: () => ({
        url: "/v3/country",
        params: { page_size: 100 },
      }),
      transformResponse: transformCountries,
      keepUnusedDataFor: 3600,
    }),
    getSiteInfo: builder.query<SiteInfo, string>({
      query: (domain) => ({
        url: `/v3/domain/${domain}`,
      }),
      transformResponse: transformSiteInfo,
    }),
  }),
  tagTypes: ["Resource"],
});

export const {
  useGetCountriesQuery,
  useLazyGetCountriesQuery,
  useGetCountryStatesQuery,
  useLazyGetCountryStatesQuery,
  useGetSiteInfoQuery,
  useLazyGetSiteInfoQuery,
} = resourceApi;
